import React, { useMemo, useState } from "react";
import EmailConfiguration from "./EmailConfiguration";
import { PatchClientEmails } from "../apis/patch";
import { Edit2 } from "lucide-react";

// ---------- Types ----------
export type BotRow = {
  Id: number | string;
  City: string;
  BotType: string;
  Emails: string;
  IsActive: number | boolean;
  UpdatedAt: string; // ISO string
  CC?: string | null;
};

export type BotGroupMap = Record<string, BotRow[]>;

type TabButtonProps = {
  label: string;
  count: number;
  isActive: boolean;
  onClick: () => void;
};

type DataTableProps = {
  rows: BotRow[];
  onEdit: (row: BotRow) => void;
};

type BotTypeTabsProps = {
  data?: BotGroupMap;
};

// ---------- Demo data (remove in production) ----------
const sampleData: BotGroupMap = {
  dining_room_sales: [
    { Id: 1, City: "Indiana", BotType: "dining_room_sales", Emails: "chatgpt.miisco@gmail.com", IsActive: 1, UpdatedAt: "2025-09-29T01:10:01.000Z", CC: "" },
    { Id: 2, City: "NC East", BotType: "dining_room_sales", Emails: "chatgpt.miisco@gmail.com", IsActive: 1, UpdatedAt: "2025-09-29T01:09:33.000Z", CC: "" },
    { Id: 3, City: "OHWV", BotType: "dining_room_sales", Emails: "chatgpt.miisco@gmail.com", IsActive: 1, UpdatedAt: "2025-09-29T01:09:33.000Z", CC: "" },
    { Id: 4, City: "Pittsburgh", BotType: "dining_room_sales", Emails: "chatgpt.miisco@gmail.com", IsActive: 1, UpdatedAt: "2025-09-29T01:09:33.000Z", CC: "" },
    { Id: 5, City: "NY", BotType: "dining_room_sales", Emails: "chatgpt.miisco@gmail.com", IsActive: 1, UpdatedAt: "2025-09-29T01:09:33.000Z", CC: "" },
    { Id: 6, City: "VA", BotType: "dining_room_sales", Emails: "chatgpt.miisco@gmail.com", IsActive: 1, UpdatedAt: "2025-09-29T01:09:33.000Z", CC: "" },
    { Id: 7, City: "NC West", BotType: "dining_room_sales", Emails: "chatgpt.miisco@gmail.com", IsActive: 1, UpdatedAt: "2025-09-29T01:09:33.000Z", CC: "" },
    { Id: 8, City: "Taco-Bell", BotType: "dining_room_sales", Emails: "chatgpt.miisco@gmail.com", IsActive: 1, UpdatedAt: "2025-09-29T01:09:33.000Z", CC: "" }
  ],
  daily_sales_report: [
    { Id: 9, City: "Indiana", BotType: "daily_sales_report", Emails: "chatgpt.miisco@gmail.com", IsActive: 1, UpdatedAt: "2025-09-29T01:09:33.000Z", CC: "" },
    { Id: 10, City: "NC East", BotType: "daily_sales_report", Emails: "chatgpt.miisco@gmail.com", IsActive: 1, UpdatedAt: "2025-09-29T01:09:33.000Z", CC: "" },
    { Id: 11, City: "OHWV", BotType: "daily_sales_report", Emails: "chatgpt.miisco@gmail.com", IsActive: 1, UpdatedAt: "2025-09-29T01:09:33.000Z", CC: "" },
    { Id: 12, City: "Pittsburgh", BotType: "daily_sales_report", Emails: "chatgpt.miisco@gmail.com", IsActive: 1, UpdatedAt: "2025-09-29T01:09:33.000Z", CC: "" },
    { Id: 13, City: "NY", BotType: "daily_sales_report", Emails: "chatgpt.miisco@gmail.com", IsActive: 1, UpdatedAt: "2025-09-29T01:09:33.000Z", CC: "" },
    { Id: 14, City: "VA", BotType: "daily_sales_report", Emails: "chatgpt.miisco@gmail.com", IsActive: 1, UpdatedAt: "2025-09-29T01:09:33.000Z", CC: "" },
    { Id: 15, City: "NC West", BotType: "daily_sales_report", Emails: "chatgpt.miisco@gmail.com", IsActive: 1, UpdatedAt: "2025-09-29T01:09:33.000Z", CC: "" },
    { Id: 16, City: "Taco-Bell", BotType: "daily_sales_report", Emails: "chatgpt.miisco@gmail.com", IsActive: 1, UpdatedAt: "2025-09-29T01:09:33.000Z", CC: "" }
  ],
  taco_bell: [
    { Id: 17, City: "Indiana", BotType: "taco_bell", Emails: "chatgpt.miisco@gmail.com", IsActive: 1, UpdatedAt: "2025-09-29T01:55:43.000Z", CC: "" },
    { Id: 18, City: "NC East", BotType: "taco_bell", Emails: "chatgpt.miisco@gmail.com", IsActive: 1, UpdatedAt: "2025-09-29T01:55:43.000Z", CC: "" },
    { Id: 19, City: "OHWV", BotType: "taco_bell", Emails: "chatgpt.miisco@gmail.com", IsActive: 1, UpdatedAt: "2025-09-29T01:55:43.000Z", CC: "" },
    { Id: 20, City: "Pittsburgh", BotType: "taco_bell", Emails: "chatgpt.miisco@gmail.com", IsActive: 1, UpdatedAt: "2025-09-29T01:55:43.000Z", CC: "" },
    { Id: 21, City: "NY", BotType: "taco_bell", Emails: "chatgpt.miisco@gmail.com", IsActive: 1, UpdatedAt: "2025-09-29T01:55:43.000Z", CC: "" },
    { Id: 22, City: "VA", BotType: "taco_bell", Emails: "chatgpt.miisco@gmail.com", IsActive: 1, UpdatedAt: "2025-09-29T01:55:43.000Z", CC: "" },
    { Id: 23, City: "NC West", BotType: "taco_bell", Emails: "chatgpt.miisco@gmail.com", IsActive: 1, UpdatedAt: "2025-09-29T01:55:43.000Z", CC: "" },
    { Id: 24, City: "Taco-Bell", BotType: "taco_bell", Emails: "chatgpt.miisco@gmail.com", IsActive: 1, UpdatedAt: "2025-09-29T01:55:43.000Z", CC: "" }
  ]
};

// ---------- Utils ----------
function classNames(...classes: Array<string | false | null | undefined>): string {
  return classes.filter(Boolean).join(" ");
}

function formatDate(iso: string): string {
  // Defensive date formatting; falls back to raw input if invalid
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return String(iso ?? "");
  return d.toLocaleString();
}

function humanizeLabel(label: string): string {
  // Avoids String.prototype.replaceAll for broader compatibility
  return label.replace(/_/g, " ");
}

// ---------- UI ----------
function TabButton({ label, count, isActive, onClick }: TabButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={classNames(
        "px-3 py-2 rounded-xl text-sm font-medium border",
        isActive
          ? "bg-black text-white border-black shadow"
          : "bg-white text-gray-700 border-gray-200 hover:bg-gray-50"
      )}
      aria-pressed={isActive}
    >
      <span className="capitalize">{humanizeLabel(label)}</span>
      {label !== "Email Configuration" && (
        <span
          className={classNames(
            "ml-2 inline-flex items-center rounded-full px-2 py-0.5 text-xs border",
            isActive
              ? "bg-white text-black border-transparent"
              : "bg-gray-100 text-gray-700 border-gray-200"
          )}
        >
          {count}
        </span>
      )}
    </button>
  );
}

function DataTable({ rows, onEdit }: DataTableProps) {
  const [q, setQ] = useState<string>("");

  const filtered = useMemo(() => {
    const needle = q.trim().toLowerCase();
    if (!needle) return rows;

    return rows.filter((r) => {
      const idStr = String(r.Id ?? "").toLowerCase();
      const city = String(r.City ?? "").toLowerCase();
      const emails = String(r.Emails ?? "").toLowerCase();
      const cc = String(r.CC ?? "").toLowerCase();
      return (
        idStr.includes(needle) ||
        city.includes(needle) ||
        emails.includes(needle) ||
        cc.includes(needle)
      );
    });
  }, [q, rows]);

  return (
    <div className="mt-4">
      <div className="mb-3 flex items-center gap-2">
        <input
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Search by City, Email, CC, Id…"
          className="w-full md:w-80 rounded-xl border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-black text-black"
          aria-label="Search rows"
        />
      </div>

      <div className="overflow-x-auto rounded-2xl border border-gray-200">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Id</th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">City</th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Emails</th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">CC</th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Is Active</th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Updated At</th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Actions</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100 bg-white">
            {filtered.map((r) => {
              const isActiveBool = typeof r.IsActive === "boolean" ? r.IsActive : r.IsActive === 1;
              return (
                <tr key={r.Id} className="hover:bg-gray-50">
                  <td className="px-4 py-3 text-sm text-gray-900">{r.Id}</td>
                  <td className="px-4 py-3 text-sm text-gray-900">{r.City}</td>
                  <td className="px-4 py-3 text-sm">
                    <a
                      className="text-blue-700 underline underline-offset-2"
                      href={`mailto:${r.Emails}`}
                    >
                      {r.Emails}
                    </a>
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-900">{r.CC && r.CC.trim() ? r.CC : "—"}</td>
                  <td className="px-4 py-3 text-sm">
                    <span
                      className={classNames(
                        "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium border",
                        isActiveBool
                          ? "bg-green-50 text-green-700 border-green-200"
                          : "bg-gray-50 text-gray-600 border-gray-200"
                      )}
                    >
                      {isActiveBool ? "Active" : "Inactive"}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-700">{formatDate(r.UpdatedAt)}</td>
                  <td className="px-4 py-3 text-sm">
                    <button
                      onClick={() => onEdit(r)}
                      className="p-1.5 text-gray-500 hover:text-black hover:bg-gray-100 rounded-lg transition-colors"
                      title="Edit Configuration"
                    >
                      <Edit2 size={16} />
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {filtered.length === 0 && (
        <div className="mt-4 text-sm text-gray-500">No results.</div>
      )}
    </div>
  );
}

// ---------- Main Component ----------
export default function BotTypeTabs({ data = sampleData }: BotTypeTabsProps) {
  const keys = useMemo(() => Object.keys(data ?? {}), [data]);
  const initialKey = keys.length > 0 ? keys[0] : "";
  const [active, setActive] = useState<string>(initialKey);
  const [editingRow, setEditingRow] = useState<BotRow | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Ensure active stays valid if data changes
  React.useEffect(() => {
    if (!active || (!keys.includes(active) && active !== "email_configuration")) {
      setActive(initialKey);
    }
  }, [active, keys, initialKey]);

  const counts = useMemo<Record<string, number>>(() => {
    const c: Record<string, number> = {};
    keys.forEach((k) => {
      c[k] = Array.isArray(data[k]) ? data[k].length : 0;
    });
    return c;
  }, [data, keys]);

  const handleUpdate = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!editingRow) return;

    setIsSubmitting(true);
    try {
      const payload = {
        city: editingRow.City,
        botType: editingRow.BotType,
        emails: editingRow.Emails,
        cc: editingRow.CC || ""
      };
      
      const response = await PatchClientEmails(payload);
      if (response && (response.status === 'success' || response.success || response.status === true)) {
        setEditingRow(null);
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      }
    } catch (error) {
      console.error("Failed to update client emails:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="mx-auto max-w-6xl p-4 md:p-8">
      <header className="mb-5 flex items-center justify-between gap-4">
        <div>
          <h1 className="text-xl md:text-2xl font-semibold tracking-tight">Client Email Groups</h1>
          <p className="text-sm text-gray-600">
            Grouped by{" "}
            <code className="bg-gray-100 rounded px-1">BotType</code>. Click a tab to switch.
          </p>
        </div>
      </header>

      {/* Tabs */}
      <div className="flex flex-wrap gap-2">
        {keys.map((k) => (
          <TabButton
            key={k}
            label={k}
            count={counts[k] ?? 0}
            isActive={active === k}
            onClick={() => setActive(k)}
          />
        ))}
        {/* Manual tab for Email Configuration */}
        <TabButton
          label=" Delaget Emails"
          count={0}
          isActive={active === "email_configuration"}
          onClick={() => setActive("email_configuration")}
        />
        {keys.length === 0 && active !== "email_configuration" && (
          <span className="text-sm text-gray-500">No groups available.</span>
        )}
      </div>

      {/* Panel */}
      <section className="mt-4">
        {active === "email_configuration" ? (
          <EmailConfiguration />
        ) : active ? (
          <DataTable rows={data[active] ?? []} onEdit={(row) => setEditingRow(row)} />
        ) : (
          <div className="text-sm text-gray-500">Select a tab to view data.</div>
        )}
      </section>

      {/* Edit Modal */}
      {editingRow && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden transform transition-all animate-in fade-in zoom-in duration-200">
            <div className="p-6">
              <div className="flex justify-between items-center mb-6">
                <h3 className="text-xl font-bold text-gray-900">Edit Configuration</h3>
                <button 
                  onClick={() => setEditingRow(null)}
                  className="text-gray-400 hover:text-gray-600"
                >
                  ✕
                </button>
              </div>
              
              <form onSubmit={handleUpdate} className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">City</label>
                  <input 
                    type="text" 
                    value={editingRow.City} 
                    disabled 
                    className="w-full px-4 py-2 bg-gray-100 border border-gray-200 rounded-xl text-gray-500 cursor-not-allowed"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Bot Type</label>
                  <input 
                    type="text" 
                    value={humanizeLabel(editingRow.BotType)} 
                    disabled 
                    className="w-full px-4 py-2 bg-gray-100 border border-gray-200 rounded-xl text-gray-500 cursor-not-allowed"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Emails (comma separated)</label>
                  <textarea 
                    rows={3}
                    value={editingRow.Emails} 
                    onChange={(e) => setEditingRow({ ...editingRow, Emails: e.target.value })}
                    className="w-full px-4 py-2 border border-gray-300 rounded-xl focus:ring-2 focus:ring-black focus:border-transparent outline-none transition-all text-black"
                    placeholder="email1@example.com, email2@example.com"
                    required
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">CC (comma separated)</label>
                  <textarea 
                    rows={2}
                    value={editingRow.CC || ""} 
                    onChange={(e) => setEditingRow({ ...editingRow, CC: e.target.value })}
                    className="w-full px-4 py-2 border border-gray-300 rounded-xl focus:ring-2 focus:ring-black focus:border-transparent outline-none transition-all text-black"
                    placeholder="cc1@example.com, cc2@example.com"
                  />
                </div>

                <div className="flex gap-3 mt-8">
                  <button
                    type="button"
                    onClick={() => setEditingRow(null)}
                    className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 font-semibold rounded-xl hover:bg-gray-50 transition-colors"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="flex-1 px-4 py-2 bg-black text-white font-semibold rounded-xl hover:bg-gray-800 transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
                  >
                    {isSubmitting ? (
                      <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                      </svg>
                    ) : (
                      "Save Changes"
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
